import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table } from 'ui/table';
import { PaginationFooter } from 'ui/paginationFooter';
import { useClientPaginatedState } from 'ui/table/hooks/useClientPaginatedState';
import { TableHeader } from 'ui/tableHeader';
import { TableRows } from 'ui/tableRows';
import { InputText } from 'ui/inputs/inputText';
import { PageHeader } from 'ui/pageHeader';
import { selectIsUuidBasedProject } from 'core/userContext';
import { fetchPurchasesRequest } from '../actions';
import { selectPurchases } from '../selectors';
import { configureTableColumns, purchasesFilterFn } from '../utils';

export const Purchases = () => {
  const dispatch = useDispatch();
  const purchases = useSelector(selectPurchases);
  const isUuidBased = useSelector(selectIsUuidBasedProject);
  const COLUMNS = useMemo(() => configureTableColumns(isUuidBased), [isUuidBased]);

  const {
    currentPage,
    filter,
    itemsPerPage,
    numItems,
    rows,
    setCurrentPage,
    setFilter,
    setItemsPerPage,
    setSortDirection,
    setSortedBy,
    sortDirection,
    sortedBy,
  } = useClientPaginatedState({
    rows: purchases,
    sortedBy: 'id',
    filterFn: purchasesFilterFn,
  });

  useEffect(() => {
    dispatch(fetchPurchasesRequest());
  }, [dispatch]);

  return (
    <>
      <PageHeader
        pageActions={
          <InputText
            data-test="filter-enabled-accounts"
            value={filter}
            onChange={setFilter}
            placeholder={'Filter by...'}
          />
        }
      >
        Purchase log
      </PageHeader>
      <Table>
        <TableHeader
          columns={COLUMNS}
          sortDirection={sortDirection}
          setSortDirection={setSortDirection}
          sortedBy={sortedBy}
          setSortedBy={setSortedBy}
        />
        <TableRows columns={COLUMNS} rows={rows} />
      </Table>
      <PaginationFooter
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        numItems={numItems}
        onUpdate={({ page, pageSize }) => {
          setCurrentPage(page);
          setItemsPerPage(pageSize);
        }}
      />
    </>
  );
};
